import { SectionHeader } from '@/components/ui';
import type { SaleHistoryEntry } from '@/seo/brandHubs';
import { hasEnoughSaleHistory } from '@/seo/brandHubs';

export interface NextSalePatternProps {
  brandName: string;
  /** Sale history rows — must be ≥ 3 for the section to render. */
  saleHistory: readonly SaleHistoryEntry[];
  className?: string;
}

/**
 * "When is the next {Brand} sale?" section (web plan W3.6).
 *
 * Renders only when there are ≥ 3 past sales. Stated as a historical pattern
 * only — no prediction guarantee.
 */
export function NextSalePattern({ brandName, saleHistory, className }: NextSalePatternProps) {
  if (!hasEnoughSaleHistory(saleHistory)) return null;
  const title = `When is the next ${brandName} sale?`;
  return (
    <section aria-label={title} className={className}>
      <SectionHeader title={title} />
      <p className="mt-3 text-sm leading-relaxed text-ink-secondary">
        Based on {saleHistory.length} past sales tracked on PromoStork, {brandName} has
        historically run promotions. There is no guarantee of future sales. Follow{' '}
        {brandName} above to get an alert as soon as the next sale is announced.
      </p>
    </section>
  );
}

export default NextSalePattern;
